import React from "react";
import { useTranslation } from "react-i18next";
import "./PasswordHint.scss";

type Props = { password: string; confirmPassword: string; className?: string };

const PasswordMatchHint: React.FC<Props> = ({
	password,
	confirmPassword,
	className = "",
}) => {
	const { t } = useTranslation();
	if (!confirmPassword) return null;

	const match = password === confirmPassword;
	return React.createElement(
		"div",
		{
			className:
				`password-hint ${match ? "rule-passed" : "rule-failed"} ${className}`.trim(),
			"aria-live": "polite",
		},
		match ? t("Passwords match") : t("Passwords do not match")
	);
};

export default PasswordMatchHint;
